import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { AssessmentDetails } from "Assessments";
import { LeDetails } from "LearningEngagement";
import { injectReducer } from "store/reducers";
export default store => {
  return {
    path: ":step_id",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "unit-planner" */ "./components"),
          import(
            /* webpackChunkName: "unit-planner" */ "OrganizationResources/modules/OrganizationResourcesModule"
          ),
        ]).then(([importedModule0, importedModule1]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          injectReducer(store, {
            key: "organizationResource",
            reducer,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [AssessmentDetails(store), LeDetails(store)],
  };
};
